import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionPreloadStrategy implements PreloadingStrategy {
  constructor(private authService: AuthService) {}

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // If user is not authenticated, don't preload
    if (!this.authService.isAuthenticated) {
      return of(null);
    }

    // Check if route has a permission requirement
    const requiredPermission = route.data?.['permission'] as string;

    if (requiredPermission) {
      // Only preload if user has the required permission
      if (this.authService.hasPermission(requiredPermission)) {
        return load();
      }
      return of(null);
    }

    // If no permission required, preload it (e.g., recipes route)
    return load();
  }
}

